// extracted by mini-css-extract-plugin
export default {"mainDiv":"Wings_mainDiv__lLHsD","checkbox":"Wings_checkbox__B2x-0","container":"Wings_container__iaDC8","checkmark":"Wings_checkmark__mA0EF"};